import { useEffect, useState } from 'react'
import SelectWithLabel from 'components/UI/SelectWithLabel'
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from 'file-saver'
import { ReactDataContext } from '@themost/react';
import Loader from "react-loader-spinner";

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ExportExcel(props) {
    const [selectedId, setSelectedId] = useState(0)
    const [loading, setLoading] = useState(true);
    const [dep, setDep] = useState("")
    const [departments, setDepartments] = useState([])
    const [statusSelected, setStatusSelected] = useState(null)
    const [ewpStatusSelected, setEwpStatusSelected] = useState(null)
    const [localFinalizedSelected, setLocalFinalizedSelected] = useState(null)
    const [isActiveSelected, setIsActiveSelected] = useState(null)
    const [startYearSelected, setStartYearSelected] = useState(null)
    const [academicYears, setAcademicYears] = useState([])
    const [ewpStatuses, setEwpStatuses] = useState([])
    const context = new ReactDataContext(process.env.REACT_APP_API_SERVER);
    context.setBearerAuthorization(props.userService.getToken());

    useEffect(() => {
        document.title = props.title
    }, [])

    useEffect(() => {
        (async () => {
            try {
                const [authDepartmentsResult, academicYearsResult, ewpStatusesResult] = await Promise.all([
                    context.model(`MobilityDepartments`).where('institution/isLocal').equal(true).take(-1).getItems(),
                    context.model(`AcademicYears`).where('id').greaterOrEqual(2014).take(-1).getItems(),
                    context.model(`MobilityEwpStatuses`).asQueryable().take(-1).getItems(),
                ]);
                setDepartments(authDepartmentsResult)
                setAcademicYears(academicYearsResult)
                setEwpStatuses(ewpStatusesResult)
            } catch (err) {
                console.log(err)
            } finally {
                setLoading(false)
            }
        })()
    }, [])

    /**
     *
     * @param e
     */
    const handleSelectChange = (e) => {

        if (e !== null && departments.find(i => i.name === e.label)) {
            setDep(e.label)
            setSelectedId(e.value)

        }
        else {
            setDep("")
            setSelectedId(0)
        }

    }
    if (loading) {
        return (<div style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
        }}>
            <Loader
                className="spinner mx-auto"
                type="TailSpin"
                color="#3A435E"
                height={70}
                width={70}
            />
        </div>)
    }
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">

                    <SelectWithLabel
                        id="dep"
                        placeholderText="Type department"
                        clearable={true}
                        value={dep}
                        onSelectChange={handleSelectChange}
                        listOptions={departments.map(i => ({ value: i.id, label: i.name }))}

                    >
                        <h4>Select Department</h4>
                    </SelectWithLabel>

                    <div className="bg-light pt-2 filter-sidebar mt-3 px-3">
                        <div className="row">
                            <div className="col-md-12">
                                <p className="font-weight-bold text-center">Optional Filters</p>
                            </div>
                        </div>
                        <div className="form-group">
                            <SelectWithLabel
                                value={statusSelected ? (statusSelected === 1 ? "Draft" : statusSelected === 2 ? "Submitted" : "Final") : ""}
                                onSelectChange={(e) => {
                                    if (e != null) {
                                        setStatusSelected(e.value)
                                    }
                                    else {
                                        setStatusSelected(null)
                                    }
                                }}
                                id="status"
                                clearable={true}
                                listOptions={[{ value: 1, label: "Draft" }, { value: 2, label: "Submitted" }, { value: 3, label: "Final" }]}
                            >
                                Status
                            </SelectWithLabel>
                        </div>
                        <div className="form-group">
                            <SelectWithLabel
                                value={ewpStatusSelected ? (ewpStatuses.find(i => i.id === ewpStatusSelected)?.name ?? '') : ''}
                                onSelectChange={(e) => {
                                    if (e != null) {
                                        setEwpStatusSelected(e.value)
                                    }
                                    else {
                                        setEwpStatusSelected(null)
                                    }
                                }}
                                id="ewp-status"
                                clearable={true}
                                listOptions={ewpStatuses.map(i => ({ value: i.id, label: i.name }))}
                            >
                                EWP Status
                            </SelectWithLabel>
                        </div>
                        <div className="form-group">
                            <SelectWithLabel
                                value={localFinalizedSelected === "1" ? 'Local Finalised' :
                                localFinalizedSelected === "2" ? 'Refused by us' :
                                localFinalizedSelected === "3" ? 'Refused by part' :
                                localFinalizedSelected === "4" ? 'In Progress' :
                                localFinalizedSelected === "5" ? 'Not Finalized' :
                                localFinalizedSelected === "6" ? 'Replaced' : ''}
                                onSelectChange={(e) => {
                                    if (e != null) {
                                        setLocalFinalizedSelected(e.value)
                                    }
                                    else {
                                        setLocalFinalizedSelected(null)
                                    }
                                }}
                                id="localFinalized"
                                clearable={true}
                                listOptions={
                                [ 
                                    { value: "1", label: "Local Finalised" },
                                    { value: "2", label: "Refused by us" },
                                    { value: "3", label: "Refused by partner" },
                                    { value: "4", label: "In Progress" },
                                    { value: "5", label: "Not Finalized" },
                                    { value: "6", label: "Replaced" }
                                ]}
                            >
                                Local Status
                            </SelectWithLabel>
                        </div>
                        <div className="form-group">
                            <SelectWithLabel
                                value={isActiveSelected === "0" ? 'No' : isActiveSelected === "1" ? 'Yes' : ''}
                                onSelectChange={(e) => {
                                    if (e != null) {
                                        setIsActiveSelected(e.value)
                                    }
                                    else {
                                        setIsActiveSelected(null)
                                    }
                                }}
                                id="isActive"
                                clearable={true}
                                listOptions={[{ value: "0", label: "No" }, { value: "1", label: "Yes" }]}
                            >
                                Export only active IIAs
                            </SelectWithLabel>
                        </div>
                        <div className="form-group">
                            <SelectWithLabel
                                value={startYearSelected ? startYearSelected + "-" + (startYearSelected + 1) : ''}
                                onSelectChange={(e) => {
                                    if (e != null) {
                                        setStartYearSelected(e.value)
                                    }
                                    else {
                                        setStartYearSelected(null)
                                    }
                                }}
                                id="startYear"
                                isOptionDisabled={(option) => option.value > new Date().getUTCFullYear() + 1}
                                clearable={true}
                                listOptions={academicYears.map(i => ({ value: i.id, label: i.name }))}
                            >
                                Start Year
                            </SelectWithLabel>
                        </div>
                    </div>

                </div>
            </div>

            <div className="d-flex justify-content-center">
                <button className="btn btn-next mt-4" onClick={async () => {
                    setLoading(true)

                    const wb = new Excel.Workbook()
                    const ws = wb.addWorksheet()
                    ws.columns = [
                        { header: 'ID', key: 'id', width: 10 },
                        { header: 'Υπεύθυνος Συμφωνίας', key: 'coordinator', width: 15 },
                        { header: 'Όνομα Ιδρύματος', key: 'institution', width: 15, outlineLevel: 1 },
                        { header: 'Κωδικός Erasmus', key: 'erasmus', width: 10, outlineLevel: 1 },
                        { header: 'Από', key: 'startYear', width: 7, outlineLevel: 1 },
                        { header: 'Έως', key: 'endYear', width: 7, outlineLevel: 1 },
                        { header: 'Θεματική ενότητα', key: 'subjectaArea', width: 10, outlineLevel: 1 },
                        { header: 'Τμήμα', key: 'department', width: 15, outlineLevel: 1 },
                        { header: 'Δράση', key: 'action', width: 20, outlineLevel: 1 },
                        { header: 'Εξερχόμενοι', key: 'outgoing', width: 5, outlineLevel: 1 },
                        { header: 'Συνολική Διάρκεια', key: 'totalOutgoing', width: 5, outlineLevel: 1 },
                        { header: 'Εισερχόμενοι', key: 'incoming', width: 5, outlineLevel: 1 },
                        { header: 'Συνολική Διάρκεια ', key: 'totalIncoming', width: 5, outlineLevel: 1 }

                    ];
                    let query = context.model(`MobilityAgreements`).asQueryable()
                        .where('departmentalCoordinatorContacts/department').equal(selectedId)

                    if (statusSelected) {
                        query = query.and('status').equal(statusSelected)
                    } else {
                        query = query.and('status').notEqual(1)
                    }

                    if (ewpStatusSelected) {
                        query = query.and('ewpStatus').equal(ewpStatusSelected)
                    }

                    if (localFinalizedSelected && localFinalizedSelected !== '0') {
                        query = query.and('localStatus').equal(localFinalizedSelected)
                    }

                    if (startYearSelected) {
                        query = query.and('startYear').equal(startYearSelected)
                    }

                    if (isActiveSelected === "1") {
                        const date = new Date();
                        let currentAcademicYear = date.getFullYear();
                        if (date.getMonth() < 8) {
                            currentAcademicYear = currentAcademicYear - 1;
                        }
                        query = query.and("endYear/id").greaterOrEqual(currentAcademicYear)
                    }

                    const resp = await query.take(-1).getItems()
                    // Add an array of rows
                    resp.forEach((i) => {
                        if (i.institutions.filter(i => i.isLocal === false).length!==0) {
                            i.institutions.filter(i => i.isLocal === false).forEach((j) => {
                                    let studentStudiesIncoming = i.studentMobilitiesForStudies.find(k => k.toInstitution.isLocal === true && k.fromInstitution.id === j.id);
                                    let studentStudiesOutgoing = i.studentMobilitiesForStudies.find(k => k.fromInstitution.isLocal === true && k.toInstitution.id === j.id);
                                    let studentTraineeshipIncoming = i.studentMobilitiesForTraineeship.find(k => k.toInstitution.isLocal === true && k.fromInstitution.id === j.id);
                                    let studentTraineeshipOutgoing = i.studentMobilitiesForTraineeship.find(k => k.fromInstitution.isLocal === true && k.toInstitution.id === j.id);
                                    let staffTeachingIncoming = i.staffMobilitiesForTeaching.find(k => k.toInstitution.isLocal === true && k.fromInstitution.id === j.id);
                                    let staffTeachingOutgoing = i.staffMobilitiesForTeaching.find(k => k.fromInstitution.isLocal === true && k.toInstitution.id === j.id);
                                    let staffTrainingIncoming = i.staffMobilitiesForTraining.find(k => k.toInstitution.isLocal === true && k.fromInstitution.id === j.id);
                                    let staffTrainingOutgoing = i.staffMobilitiesForTraining.find(k => k.fromInstitution.isLocal === true && k.toInstitution.id === j.id);
                                    let departmentalCoordinatorLocal = i.departmentalCoordinatorContacts.find(k => k.department.institution.isLocal === true && k.roles && k.roles[0] && k.roles[0].value === "Departmental Coordinator");
                                    if (!departmentalCoordinatorLocal) {
                                        departmentalCoordinatorLocal = i.departmentalCoordinatorContacts.find(k => k.department.institution.isLocal === true);
                                    }
                                    let departmentalCoordinatorPartner = i.departmentalCoordinatorContacts.find(k => k.department.institution.id === j.id);
                                    let subjectAreas = [];
                                    if (studentStudiesIncoming) {
                                        subjectAreas = subjectAreas.concat(studentStudiesIncoming.subjectAreasWithClarifications);
                                    }
                                    if (studentStudiesOutgoing) {
                                        subjectAreas = subjectAreas.concat(studentStudiesOutgoing.subjectAreasWithClarifications);
                                    }
                                    if (studentTraineeshipIncoming) {
                                        subjectAreas = subjectAreas.concat(studentTraineeshipIncoming.subjectAreasWithClarifications);
                                    }
                                    if (studentTraineeshipOutgoing) {
                                        subjectAreas = subjectAreas.concat(studentTraineeshipOutgoing.subjectAreasWithClarifications);
                                    }
                                    if (staffTeachingIncoming) {
                                        subjectAreas = subjectAreas.concat(staffTeachingIncoming.subjectAreasWithClarifications);
                                    }
                                    if (staffTeachingOutgoing) {
                                        subjectAreas = subjectAreas.concat(staffTeachingOutgoing.subjectAreasWithClarifications);
                                    }
                                    if (staffTrainingIncoming) {
                                        subjectAreas = subjectAreas.concat(staffTrainingIncoming.subjectAreasWithClarifications);
                                    }
                                    if (staffTrainingOutgoing) {
                                        subjectAreas = subjectAreas.concat(staffTrainingOutgoing.subjectAreasWithClarifications);
                                    }
                                    subjectAreas = subjectAreas.map(subject => subject.subjectArea.name + " (" + subject.subjectArea.code + ")").filter(onlyUnique).toString();
                                    ws.addRows([
                                        [
                                            i.id,
                                            departmentalCoordinatorLocal ? (departmentalCoordinatorLocal.familyName + " " + departmentalCoordinatorLocal.givenName) : null,
                                            j.name,
                                            j.erasmusCode,
                                            i.startYear.id,
                                            i.endYear.id,
                                            subjectAreas,
                                            departmentalCoordinatorPartner ? departmentalCoordinatorPartner.department.name : null,
                                            "Student Mobility for Studies", studentStudiesOutgoing ? studentStudiesOutgoing.mobilitiesPerYear : null, studentStudiesOutgoing ? studentStudiesOutgoing.totalMonthsPerYear : null, studentStudiesIncoming ? studentStudiesIncoming.mobilitiesPerYear : null, studentStudiesIncoming ? studentStudiesIncoming.totalMonthsPerYear : null],
                                        ['', '', '', '', '', '', '', '', "Student Mobility for Traineeships", studentTraineeshipOutgoing ? studentTraineeshipOutgoing.mobilitiesPerYear : null, studentTraineeshipOutgoing ? studentTraineeshipOutgoing.totalMonthsPerYear : null, studentTraineeshipIncoming ? studentTraineeshipIncoming.mobilitiesPerYear : null, studentTraineeshipIncoming ? studentTraineeshipIncoming.totalMonthsPerYear : null],
                                        ['', '', '', '', '', '', '', '', "Staff Mobility for Teaching", staffTeachingOutgoing ? staffTeachingOutgoing.mobilitiesPerYear : null, staffTeachingOutgoing ? staffTeachingOutgoing.totalDaysPerYear : null, staffTeachingIncoming ? staffTeachingIncoming.mobilitiesPerYear : null, staffTeachingIncoming ? staffTeachingIncoming.totalDaysPerYear : null],
                                        ['', '', '', '', '', '', '', '', "Staff Mobility for Training", staffTrainingOutgoing ? staffTrainingOutgoing.mobilitiesPerYear : null, staffTrainingOutgoing ? staffTrainingOutgoing.totalDaysPerYear : null, staffTrainingIncoming ? staffTrainingIncoming.mobilitiesPerYear : null, staffTrainingIncoming ? staffTrainingIncoming.totalDaysPerYear : null]
                                    ]);
                            })
                        }
                    })

                    const buf = await wb.xlsx.writeBuffer();

                    saveAs(new Blob([buf]), dep + '.xlsx');
                    setLoading(false);

                }}><i className="fa fa-file-excel-o mr-2"></i>Export</button>
            </div>
        </div>
    )
}
